import { useEffect, useState } from "react";

/**
 * Media-Query als React-Zustand — nur für die wenigen Stellen, an denen sich
 * die STRUKTUR ändert (Popover als Bottom-Sheet, Editor-Sperre auf kleinen
 * Schirmen). Alles rein Optische gehört in Tailwind-Breakpoints, nicht hierher.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    // Zwischen erstem Render und Effekt kann sich die Breite geändert haben
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

/** sm — darunter sind Popovers Bottom-Sheets. */
export const SM_QUERY = "(min-width: 640px)";
/** md — darunter ist der Hotspot-Editor nicht bedienbar. */
export const MD_QUERY = "(min-width: 768px)";
